module.exports = __webpack_public_path__ + "img/LT.67311f4d.svg";